import {
  DialogPositioningBehavior,
  DialogProps,
  DialogType,
  DialogWidget
} from '@tableau/widgets';
import React from 'react';

  import { Messages } from '~src/codegen/Localize';
import { CloseAndDismiss, ReactModalService } from '~src/commonInfra/dialogs/ReactModalService';
import { TabDialogWidth } from '~src/commonInfra/dialogs/style/TabDialogWidth';

import { KMSKeyGenerateForbiddenView } from '../components/KMSKeyGenerateForbiddenView';


export const openGenerateKMSKeyForbiddenDialog = (nextRotationDate: string, coolDownPeriod: number): void => {
      ReactModalService.openCustom(closeAndDismiss => {
          const dialogProps = ReactModalService.getDefaultDialogProps({
              type: DialogType.NormalWithTitleBar,
              title: Messages.credentialEncryptionTOLKeyGenerateKeyPrompt(),
              testId: 'generate-data-key-forbidden-dialog',
              showCloseButton: true,
              dialogWidth: TabDialogWidth.width600px,
              positioningBehavior: DialogPositioningBehavior.Draggable,
              shouldNotCloseOnGlassClick: true
          }, closeAndDismiss);
          return getDialogWidget(dialogProps, closeAndDismiss, nextRotationDate, coolDownPeriod);
      });

  };


  function getDialogWidget(dialogProps: DialogProps, closeAndDismiss: CloseAndDismiss, nextRotationDate: string, coolDownPeriod: number) {
    return (
      <DialogWidget {...dialogProps}>
        <KMSKeyGenerateForbiddenView closeDialog={closeAndDismiss} nextRotationDate={nextRotationDate} coolDownPeriod={coolDownPeriod} />
      </DialogWidget>
    );
  }